import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useParams } from "react-router-dom"

import GuestLayout from "../components/GuestLayout"

import * as cartSlice from "../store/cart"
import * as dealApis from "../utilities/apis/deal"
import { url } from "../utilities/enumerations/constants"

const Deal = () => {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)
  const { slug } = useParams()
  const [deal, setDeal] = useState(null)

  const handleCart = async () => {
    dispatch(cartSlice.addToCart({ type: "deal", ...deal }))
  }

  const handleDecrement = async () => {
    dispatch(cartSlice.handleCartDecrement(deal.slug))
  }

  const handleIncrement = async () => {
    if (cartState.cartById[deal.slug] >= 5) return alert('For more than 5 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleCartIncrement(deal.slug))
  }

  const getDeal = async () => {
    try {
      const response = await dealApis.getHomeDeal(slug)
      if (!response.status) throw new Error(response.message)

      setDeal(response.deal)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (slug) getDeal()
  }, [slug])

  if (!deal) return

  let src = "/upload-white.png"
  if (deal.thumbnail_url) src = deal.thumbnail_url.replace("public", url)

  return (
    <GuestLayout
      header={true}
      footer={true}
    >
      <div className="container py-4">
        <div className="row gy-3 gy-md-0 mb-4">
          <div className="col-md-4">
            {deal.video_url && <iframe src={deal.video_url} className="thumbnail rounded-2"></iframe>}
            {!deal.video_url && <img src={src} alt={deal.title} className="thumbnail rounded-2" />}
          </div>
          <div className="col-md-8">
            <div className="d-flex flex-column gap-4">
              <h1 className="text-body-emphasis fw-bold m-0">{deal.title}</h1>

              <div>
                <p className="text-body-tertiary fw-semibold m-0">Description</p>
                <p className="text-body-emphasis m-0">{deal.description}</p>
              </div>

              <div>
                <p className="text-body-tertiary fw-semibold m-0">Items</p>
                <div className="d-flex flex-column gap-3">
                  {deal.deal_products.map((item) => {
                    let productSrc = "/upload-white.png"
                    if (item.product.thumbnail_url) productSrc = item.product.thumbnail_url.replace("public", url)

                    return (
                      <div key={item.id} className="d-flex gap-2 align-items-center">
                        <img src={productSrc} alt={item.product.title} className="border rounded-2" width={40} height={40} />
                        <div>
                          <p className="small text-body-emphasis m-0">{item.product.title}</p>
                          <p className="small text-body-tertiary m-0">Qty: {item.quantity}</p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>

              <div className="d-flex gap-3 align-items-center">
                <p className="text-body-tertiary fw-bold text-decoration-line-through">Rs. {deal.price.toFixed(2)}</p>
                <p className="lead bg-theme-light text-theme fw-bold rounded-2 px-2">Rs. {(deal.price - deal.discount).toFixed(2)}</p>
              </div>

              {
                !cartState.cartById[deal.slug]
                  ? <button className="btn btn-theme rounded-2 w-25" onClick={handleCart}>Add to Cart</button>
                  : <div className="d-flex gap-3 align-items-center w-50">
                    <div className="d-flex gap-3 align-items-center w-50">
                      <button type="button" className="btn btn-light-theme rounded-2 flex-grow-1" onClick={handleDecrement}><i className="bi bi-dash-lg"></i></button>
                      <p className="flex-grow-1 fs-5 text-body-secondary text-center fw-bold m-0">{cartState.cartById[deal.slug]}</p>
                      <button type="button" className="btn btn-light-theme rounded-2 flex-grow-1" onClick={handleIncrement}><i className="bi bi-plus-lg"></i></button>
                    </div>
                    <Link to="/cart" className="btn btn-light rounded-2 flex-grow-1">Go to Cart</Link>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    </GuestLayout>
  )
}

export default Deal